import React from "react";
import { Paper } from "@mui/material";

const BRAND = {
  border: "#E1E8ED",
};

export default function SurfaceCard({children, sx}) {
  return (
    <Paper
      elevation={0}
      sx={{
        py: { xs: 1, md: 2 },
        px: { xs: 2, md: 3 },
        borderRadius: 3,
        border: `1px solid ${BRAND.border}`,
        bgcolor: "#fff",
        boxShadow: "0 1px 3px rgba(16,42,67,0.06), 0 8px 24px rgba(16,42,67,0.04)",
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}